export module Constants {
  export class PagingConst {
    static RecordsPerPage = 10;
  }
  export class ProfileLogConst {
    static ProfileVisited = "Create Profile Screen Visited";
    static SingleProfile = "Single profile Created";
    static BulkProfile = "Bulk profile Created using file upload";
  }
}
